export const DELETE_PLAYLIST_REQUEST = "DELETE_PLAYLIST_REQUEST";
export const DELETE_PLAYLIST_SUCCESS = "DELETE_PLAYLIST_SUCCESS";
export const DELETE_PLAYLIST_ERROR = "DELETE_PLAYLIST_ERROR";

export const deletePlaylistRequest = (payload) => ({
  type: DELETE_PLAYLIST_REQUEST,
  ...payload,
});

export const deletePlaylistSuccess = (id) => ({
  type: DELETE_PLAYLIST_SUCCESS,
  id,
});

export const deletePlaylistError = (id) => ({
  type: DELETE_PLAYLIST_ERROR,
  id,
});



// WEBPACK FOOTER //
// ./src/pages/playlists/delete/actions.js